<template>
  <div class="agent-home">
    <!--顶部导航栏-->
    <mainNav></mainNav>
    <div class="agent-body">
      <transition name="el-fade-in">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import mainNav from "@/components/public/mainNav";
import { mapGetters } from "vuex";
export default {
  name: "home",
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {
    mainNav
  },
  data() {
    return {
      show: true,
      isCollapse: true
    };
  },
  methods: {
    change() {
      this.isCollapse = !this.isCollapse;
    },
    comModule() {
      this.$router.push("viewapp");
    }
    //
  }
};
</script>
<style lang="scss" scoped>
.agent-home {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  i {
    color: #fff;
  }
  .agent-body {
    width: 100%;
    height: 100%;
  }
}
</style>
